export type AvailabilityLevel = 'low' | 'medium' | 'high';

export const getAvailabilityLevel = (available: number, total: number): AvailabilityLevel => {
    if (total <= 0) return 'low';
    const ratio = Math.max(0, available) / total;
    if (ratio > 0.5) return 'high';
    if (ratio >= 0.2) return 'medium';
    return 'low';
};
